// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2lGpQ","legacyBtn":"MutateMid_legacyBtn__MZhMy"};